import React, { useState, useEffect } from "react";
import { Plus, UserCheck, Loader2 } from "lucide-react";
import { academicService, DepartmentItem } from "../../services/academicService";

export const DepartmentManagementPage: React.FC = () => {
  const [departments, setDepartments] = useState<DepartmentItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const data = await academicService.getDepartments();
      setDepartments(data.results || data || []);
    } catch {
      setDepartments([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-5 bg-slate-900/90 border border-slate-800 rounded-xl shadow-md text-xs font-sans space-y-4">
      <div className="flex items-center justify-between pb-3 border-b border-slate-800">
        <div className="flex items-center gap-2">
          <UserCheck className="w-5 h-5 text-indigo-400" />
          <h2 className="text-base font-bold text-slate-100">Department Management & HOD Assignment</h2>
        </div>
      </div>

      {loading ? (
        <div className="p-8 text-center text-slate-400 text-xs flex items-center justify-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin text-indigo-400" /> Loading Department Records...
        </div>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-slate-800 bg-slate-950">
          <table className="w-full text-left text-xs text-slate-300">
            <thead className="bg-slate-900 text-[10px] font-mono uppercase text-slate-400 border-b border-slate-800">
              <tr>
                <th className="p-3">Code</th>
                <th className="p-3">Department Name</th>
                <th className="p-3">Faculty / School</th>
                <th className="p-3">Programs Count</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800 font-mono">
              {departments.map((d) => (
                <tr key={d.id} className="hover:bg-slate-850">
                  <td className="p-3 font-bold text-indigo-400">{d.code}</td>
                  <td className="p-3 font-sans font-bold text-slate-100">{d.name}</td>
                  <td className="p-3 text-slate-300 font-sans">{d.faculty_name || "General Academic Faculty"}</td>
                  <td className="p-3 text-slate-400">{d.programs_count || 0} Programs</td>
                </tr>
              ))}
              {departments.length === 0 && (
                <tr>
                  <td colSpan={4} className="p-8 text-center text-slate-500 font-sans">
                    No academic departments created yet for this institution.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
